import React from 'react';
import { Helmet } from 'react-helmet-async';
import { object } from 'prop-types';
import { seaticsMapBootstrapUrl, seaticsStaticMapUrlFromListing } from '../../util/seaticsMapUrls';
import { tnListingUnavailableReason } from '../../util/tnSeaticsEmptyInventory';
import { isListingLibraryImagesEnabled } from '../../util/listingLibraryImages';

/** LCP head hints for TN listing pages (static map preload + MapAndLayout script). */
const ListingSeaticsHeadPreloads = props => {
  const { listing } = props;
  const publicData = listing?.attributes?.publicData || {};
  const staticMapUrl = seaticsStaticMapUrlFromListing(listing);
  // Closed / past-date pages never boot the widget — don't preload its script.
  // The static map preload stays: it paints (dimmed) behind the sold-out panel as LCP.
  const bootstrapScriptUrl = tnListingUnavailableReason(listing)
    ? null
    : seaticsMapBootstrapUrl(publicData);
  if (!staticMapUrl && !bootstrapScriptUrl) {
    return null;
  }
  return (
    <Helmet>
      <link rel="preconnect" href="https://maps.seatics.com" crossOrigin="anonymous" />
      {isListingLibraryImagesEnabled() ? null : (
        <link rel="preconnect" href="https://sharetribe.imgix.net" crossOrigin="anonymous" />
      )}
      {staticMapUrl ? (
        <link rel="preload" as="image" href={staticMapUrl} fetchpriority="high" />
      ) : null}
      {bootstrapScriptUrl ? (
        <link rel="preload" as="script" href={bootstrapScriptUrl} />
      ) : null}
    </Helmet>
  );
};

ListingSeaticsHeadPreloads.propTypes = {
  listing: object.isRequired,
};

export default ListingSeaticsHeadPreloads;
